export type RecommendationStatus = "draft" | "approved" | "published";

export interface CandidateProduct {
	productId: number;
	productName: string | null;
	productUrl?: string | null;
	clicks: number;
	avgPosition: number;
}

export interface QueryCandidate {
	query: string;
	searches: number;
	zeroResultSearches: number;
	curated: boolean;
	products: CandidateProduct[];
}

export interface CategoryRef {
	categoryId: number;
	name: string;
}

export interface ProductRef {
	productId: number;
	name: string;
	gtin?: string;
	url?: string | null;
}

export interface Suggestion {
	orderedProductIds: number[];
	categoryIds: number[];
	synonyms: string[];
	intent: string;
	model?: string;
	candidateProducts: CandidateProduct[];
	categories: CategoryRef[];
}

export interface RecommendationRow {
	id: number;
	normalizedQuery: string;
	productIds: number[];
	categoryIds: number[];
	synonyms: string[];
	intent: string | null;
	source: string;
	status: RecommendationStatus;
	locked: boolean;
	notes: string | null;
	updatedBy: string | null;
	model: string | null;
	updatedAt: string | null;
}

export interface RecommendationDetail extends RecommendationRow {
	candidateSnapshot: CandidateProduct[];
	products: ProductRef[];
	categories: CategoryRef[];
}

export interface RecommendationPage {
	items: RecommendationRow[];
	total: number;
	page: number;
	totalPages: number;
}

export interface AliasRow {
	id: number;
	alias: string;
	canonicalQuery: string;
	source: string;
	status: RecommendationStatus;
	notes: string | null;
	updatedBy: string | null;
	updatedAt: string | null;
}

export interface RunRow {
	id: number;
	startedAt: string | null;
	finishedAt: string | null;
	windowDays: number;
	queriesConsidered: number;
	draftsCreated: number;
	draftsUpdated: number;
	aliasesCreated: number;
	skippedLocked: number;
	status: "running" | "ok" | "failed";
	error: string | null;
}

/// What the editor holds while a curation is being assembled.
export interface EditorState {
	id: number | null;
	query: string;
	products: ProductRef[];
	categories: CategoryRef[];
	synonyms: string[];
	intent: string;
	notes: string;
	status: RecommendationStatus;
	locked: boolean;
	candidateSnapshot: CandidateProduct[];
	model: string | null;
}

export const emptyEditor = (query = ""): EditorState => ({
	id: null,
	query,
	products: [],
	categories: [],
	synonyms: [],
	intent: "",
	notes: "",
	status: "approved",
	locked: true,
	candidateSnapshot: [],
	model: null,
});
